export default "__VITE_PUBLIC_ASSET__a54f9ca4__"